import React, { useContext, useReducer, useCallback, useEffect } from 'react';
import { useApi } from '@cmr/react-api-hook';
import actions from './actions';
import { Dataset, DatasetRecordChanges, IDatasetsContext } from './types';

import reducer, { initState } from './reducers';
import { useSignalR } from '../signalr/context';

const endpoint = `${process.env['REACT_APP_API_ENDPOINT']}datasets`;
export const DatasetsContext = React.createContext<IDatasetsContext | null>(
  null,
);
interface DatasetsProviderOptions {
  children: React.ReactElement;
}

export const useDatasets = () => useContext(DatasetsContext)!;

export const DatasetsProvider = ({ children }: DatasetsProviderOptions) => {
  const [state, dispatch] = useReducer(reducer, initState);
  const { apiFetch } = useApi();
  const { connection } = useSignalR();

  useEffect(() => {
    connection?.on(
      'signalR/DatasetRecordChanges',
      (payload: DatasetRecordChanges) =>
        dispatch(actions.datasetRecordChanges(payload)),
    );
  }, [connection]);

  const fetchAvailable = useCallback(
    () => apiFetch(endpoint, dispatch, actions.fetchAvailable),
    [apiFetch],
  );

  const fetch = useCallback(
    (name: string) =>
      apiFetch(
        [endpoint, name].join('/'),
        dispatch,
        actions.fetch,
        undefined,
        name,
      ),
    [apiFetch],
  );

  return (
    <DatasetsContext.Provider
      value={{
        ...state,
        fetch,
        fetchAvailable,
        add: (ds: Partial<Dataset>) => dispatch(actions.add(ds))
      }}
    >
      {children}
    </DatasetsContext.Provider>
  );
};
